<template>
	<div id="developdocument_box">
		
		<div class="exploit_mainblank">
			
			<div class="exploit_mainleft">
				
				<div class="exploit_mainleft1">
					
					<div class="exploit_mainleft2">
						
						<input
							@keyup='filter(filterText)'
							placeholder="输入关键字进行过滤"
							v-model="filterText">
						</input>
						
						<div id="search_hint" style="display: none;">
							暂无数据
						</div>
						
						<ul id="mulu" style="text-align: left;">
							
							<li @click.stop="showHide(xiabiao)" class="documentp"  v-for="(item,xiabiao) in treeList">
								
								{{item.label}}
								
								<ul class="'secondlevel'+xiabiao" >
									
									<li @click.stop="listdetail(xiabiao,index,$event)" class="documentc" v-for="(i,index) in item.children">{{i.label}}</li>
								
								</ul>
							
							</li>
						
						</ul>
					
					</div>
				
				</div>
			
			</div>
			
			<div class="exploit_mainright">
				<!--开发文档详情-->
				<div id="developdoc_content" v-html="developement_rdt"></div>
			
			</div>
		
		</div>
	
	</div>

</template>

<script>
	import '../router/jquery-3.3.1.min.js'
	import Bus from '@/bus.js'
	export default {
		data() {
			return {
				keyword:'', //接收首页传来的关键字
				developement_rdt:``,// 开发文档富文本内容
				treeList:'',		//列表数据
				filterText: '',		//列表筛选
			};
		},
		created(){
				
		},
		mounted:function(){
			//加载动画
			let loading=this.$loading({
					body: true,
			          lock: true,
//			          text: 'Loading',
			          spinner: 'null',
			          background: 'rgba(0, 0, 0, 0.7)'
			        });
			let _this= this;
			//接收首页关键字
			_this.keyword=_this.$route.query.keyword;
			document.getElementsByClassName('commonfoot')[0].style.display='none';
			//获取数据
			this.$http.get(
				_this.apiUrl+'index.php?m=Api&c=Content&a=getHelpContent',
				).then(response => {
					
						 //判断是否成功
						if(response.body.status == 1){
							document.getElementsByClassName('commonfoot')[0].style.display='blcok';
							//数据绑定
							
							this.treeList = response.body.data;
							//接收完数据之后的回调
							_this.$nextTick(function () {
								//关闭加载动画
								loading.close();
								//如果接收到首页的数据，按关键字打开详情，没有默认展开第一个
								if(_this.keyword){
									$("li:contains("+_this.keyword+")")[1].click()
								}else{
									$("#mulu li li")[0].click()
								}
                			});
							document.getElementsByClassName('commonfoot')[0].style.display='block';
						}else{
							 //显示空白页
						}
			
			}, response => {
//				console.log("error");
			});
		},
		beforeUpdate(){
			Bus.$on('document_content',(data) => {
				this.developement_rdt=data;
			})
		},
		methods: {
			//一级目录展开关闭
			showHide(index){
				let lis = $('#mulu li');
				let li = $('#mulu>li');
				let levs = $('#mulu li>ul');
				if(levs.eq(index)[0].style.display=='none'){
					lis.css({'color':'#606266','background':'none'})
					levs.eq(index).css("display","block");
//					li.eq(index)[0].style.color='#076bf2'; //一级目录颜色 
					li.eq(index).find('li').eq(0).css({'color':'#076bf2','background':'#F0F7FF'})
					Bus.$emit('document_content',this.treeList[index].children[0].url.substr(0));
					return
				}
				levs.eq(index).css('display','none')
			},
			//筛选方法
			filter(value) {
				$('#mulu li>ul').css('display','block')
				$('#mulu  li').css('display','none')
				let lis = $("li:contains("+value+")");
				console.log(lis.length)
				if(lis.length==0){
					$('#search_hint').css('display','block')
				}else{
					$('#search_hint').css('display','none')
					lis.css('display','block')
				}
			},
			//查看文档详情
			listdetail(xiabiao,index,event){
				window.scrollTo(0,0);
				let levsecond = $('#mulu li:has(ul) li'); 
				let li = $('#mulu li');
				$('#mulu li:has(ul)').css('color','#606266');
				$('#mulu li:has(ul)').eq(xiabiao).css('color','#076bf2');
				li.css({'color':'#606266','background':'none'})
				event.target.style.color='#076bf2';
				event.target.style.background='#F0F7FF';
				Bus.$emit('document_content',this.treeList[xiabiao].children[index].url.substr(0))
			}
		}
	}
</script>

<style>
	#search_hint{
		margin-top: -10px;
		width: 100%;
		height: 60px;
		line-height: 60px;
		background: #f3f3f3;
		font-size: 18px;
		color: #666;
		font-weight: 600;
		margin-bottom: 20px;
	}
	.documentp{
		color: #606266;
		font-weight: 600;
		line-height: 30px;
		cursor: pointer;
	}
	.documentc{
		font-weight: 500;
		cursor: pointer;
		text-indent: 24px;
		line-height: 30px;
		height: 30px;
	}
	#developdoc_content{
		text-align: left;
	}
	#developdocument_box{
		width: 100%;
		overflow: hidden;
		background: white;
		padding-top: 40px;
		padding-bottom: 30px;
		min-height: 800px;
	}
	.exploit_mainblank {
		box-sizing: border-box;
		width: 1200px;
		margin: 0 auto;
	}
	
	.exploit_mainleft {
		overflow: hidden;
		width: 275px;
		float: left;
		overflow: auto;
	}
	.exploit_mainleft1 {
		height: 100%;
		width: 99%;
		/*border: 1px solid #F3F3F3;*/
		background-color: #F3F3F3;
		margin-top: 3px;
		overflow: hidden;
	}
	
	.exploit_mainleft_tree {
		width: 100%;
		/*height: 100%;*/
		float: left;
		text-align: left;
	}
	
	.exploit_mainleft2 {
		width: 230px;
		margin-left: 22px;
		margin-top: 10px;
	}
	
	.exploit_mainleft2>input{
		text-indent: 10px;
		height: 40px;
		width: 100%;
		line-height: 40px;
		font-size: 16px;
		border: #999999;
		background: #fff;
		margin-bottom: 10px;
	}
	
	.help_icon-search {
		background: url(../assets/img/help/sousuo.png) no-repeat 0 0;
		height: 10px;
		width: 157px;
		padding-left: 49px;
		padding-top: 10px;
		padding-bottom: 10px;
		line-height: 20px;
		background-color: white;
	}
	/**右侧内容*/
	
	.exploit_mainright {
		width: 75%;
		float: left;
		margin-left: 20px;
	}
	.el-tree__empty-block{
		margin-bottom: 15px ;
	}
	#mulu li{
		font-size: 14px;
		list-style: none;
	}
	/*加载动画*/
	.el-loading .circular{
		display: none;
		
	}
	.el-loading-spinner{
		background: url(../assets/images/loading.gif) center no-repeat;
		background-size: 48px 48px;
		width: 100%;
		height: 100px;
		position: absolute;
		top: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/views/tree.vue